import { TextStyle } from '@coast/schemas';
import { TextProps } from '@shared/components/Text';
import { Colors } from '@shared/styles';

export type TextStyleProps = Pick<TextProps, 'size' | 'weight' | 'italic'>;

const textPropsByTextStyle = {
  h1: { size: 'h1' },
  h2: { size: 'h2' },
  h3: { size: 'h3' },
  h4: { size: 'h4' },
  subtitle: { size: 'subtitle' },
  body1: { size: 'body1' },
  body1inactive: { size: 'body1', italic: true },
  body1bold: { size: 'body1', weight: 'semibold' },
  body2: { size: 'body2' },
  body2bold: { size: 'body2', weight: 'semibold' },
  overline: { size: 'overline' },
  overlinebold: { size: 'overline', weight: 'semibold' },
  caption1: { size: 'caption1' },
  caption1bold: { size: 'caption1', weight: 'semibold' },
  caption2: { size: 'caption2' },
  caption2bold: { size: 'caption2', weight: 'semibold' },
} satisfies Partial<Record<TextStyle, TextStyleProps>>;

export function getTextPropsFromTextStyle(textStyle?: TextStyle): TextStyleProps {
  if (!textStyle) {
    return { size: 'body1' };
  }
  return textPropsByTextStyle[textStyle] ?? { size: 'body1' };
}

export interface ThemeColors {
  foregroundActive: string;
  foregroundInactive: string;
  error: { foreground: string };
}

export function resolveTextColorProps(
  color: string | undefined,
  colors: ThemeColors,
): Pick<TextProps, 'inactive' | 'danger' | 'accent' | 'color'> {
  if (!color) {
    return {};
  }
  if (color === colors.foregroundActive) {
    return {};
  }
  if (
    color === colors.foregroundInactive ||
    color === Colors.v2.gray30 ||
    color === Colors.v2.gray50
  ) {
    return { inactive: true };
  }
  if (color === colors.error.foreground) {
    return { danger: true };
  }
  if (color === Colors.v2.green) {
    return { accent: true };
  }
  return { color };
}
